import React, { useEffect, useState } from "react";
import {
  EMPLOYEE_PROFILE,
  TOP_CALLER_API,
  TOP_PERFORMER_API,
} from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";
import TopPerformance from "../../Components/Common/TopPerformance";
const api = new APIClient();

//callerData
const TopPerformanceEmployee = ({
  formattedDates,
  selectedEmployeeOptions,
  employeeData,
  EmployeeDefaultWithoutTeam
}) => {
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const [topPerformer, setTopPerformer] = useState([]);
  const [topEmployeeData, setTopEmployeeData] = useState([]);
  const endsDate = formattedDates.endDate + "T23:59:59";

  let filteredData;
  const formattedEndDate = new Date(endsDate);
  const endDate = new Date(formattedEndDate).getTime();
  const permissionType = JSON.parse(localStorage.getItem("permission"));

  const convertToTimestamp = (dateStr) => {
    return new Date(dateStr).getTime();
  };

  const formatDuration = (duration) => {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  };
  
//This function will call /call-reports/get-top-performer api
  const fetchCallerData = async (defaultId,strDate,enndDate) => {
    let data = {};
      data = {
        startRange: strDate,
        endRange: endDate,
        employeeIds: defaultId.length>0 ? defaultId : EmployeeDefaultWithoutTeam.map((employee) => employee.id),
      };
    try {
      const response = await api.create(TOP_PERFORMER_API, data);
      if (response.data) {
        const { topCaller, topDialer, highestCallDuration, topAnswered } =
          response.data;

        setTopPerformer({
          TopCallerFullName: topCaller?.fullName,
          TopCallerCallCount: topCaller?.count,
          TopCallerProfileImageUrl: topCaller?.profileImageUrl,

          TopDialerFullName: topDialer?.fullName,
          TopDialerCallCount: topDialer?.count,
          TopDialerProfileImageUrl: topDialer?.profileImageUrl,

          HighestDurationFullName: highestCallDuration?.fullName,
          HighestDurationDuration: highestCallDuration?.count,
          HighestDurationProfileImageUrl: highestCallDuration?.profileImageUrl,

          TopAnsweredFullName: topAnswered?.fullName,
          TopAnsweredAnswerCount: topAnswered?.count,
          TopAnsweredProfileImageUrl: topAnswered?.profileImageUrl,
        });
      } else {
        console.error("Error: API response is not successful.");
      }
    } catch (error) {
      console.error("Error fetching caller data:", error);
    }
  };

  //This function will call fetchCallerData
  const fetchData = async () => {
    const updatedIds =
      selectedEmployeeOptions?.map((userid) => userid?.id) || [];
    try {
      const defaultId =  selectedEmployeeOptions?.map((option) => option?.id) || [];
      if (formattedDates?.startDate && formattedDates?.endDate) {
        const newStartTime = convertToTimestamp(formattedDates.startDate);
        const newEndTime = convertToTimestamp(formattedDates.endDate);
        if (
          loginType === "organization" ||
          (loginType === "employee" && permissionType.length > 0)
        )
          await fetchCallerData(
           updatedIds || defaultId,
            newStartTime,
            newEndTime
          );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (employeeData.length > 0) {
      fetchData();
    }
  }, [employeeData]);

  //This function will call /call-reports/top-callers
  const fetchNewData = async () => {
    const response = await api.get(`${EMPLOYEE_PROFILE}`);
    const id = response?.data?._id;
    const newStartTime = convertToTimestamp(formattedDates.startDate);
    let data = {
      startRange: newStartTime,
      endRange: endDate,
      filterField: "callCount",
      employeeIds: id,
    };
    try {
      const response = await api.create(`${TOP_CALLER_API}`, data);
      if (response.success) {
        filteredData = response.data.map((item) => ({
          fullName: item.fullName,
          overall_rank: item.overall_rank,
          team_ranks: item.team_ranks,
          callCount: item.callCount,
          totalOutgoing: item.totalOutgoing,
          totalIncoming: item.totalIncoming,
          totalAnswered: item.totalAnswered,
          team_ranks: item.team_ranks,
          profileImageUrl: item.profileImageUrl,
          id: item._id,
          totalDuration: item.totalDuration,
        }));

        filteredData.forEach((item) => {
          setTopEmployeeData(item);
        });
      } else {
        console.error("Error fetching data:", response.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    try {
      const defaultId =
        selectedEmployeeOptions?.map((option) => option?.id) || [];
      if (loginType === "employee" && permissionType.length == 0) {
        fetchNewData(defaultId);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [employeeData]);

  return (
    <div>
      <div className="row">
        {loginType === "organization" ||
        (loginType === "employee" && permissionType.length > 0) ? (
          <div className="col-md-12 col-sm-12">
            <div className="row-- sn-top-cannected-employee">
              <TopPerformance
                topEmployeeData={topEmployeeData}
                employeeData={employeeData}
                topPerformer={topPerformer}
                formatDuration={formatDuration}
              />
            </div>
          </div>
        ) : (
          <div className="col-md-12 col-sm-12">
            <div className="row sn-top-cannected-employee">
              <TopPerformance
                employeeData={employeeData}
                topEmployeeData={topEmployeeData}
                formatDuration={formatDuration}
              />
            </div>
          </div>
          // })
        )}
      </div>
    </div>
  );
};

export default TopPerformanceEmployee;
